import { render, staticRenderFns } from "./block-sending.vue?vue&type=template&id=30f1b224&scoped=true"
import script from "./block-sending.vue?vue&type=script&lang=js"
export * from "./block-sending.vue?vue&type=script&lang=js"
import style1 from "./block-sending.vue?vue&type=style&index=1&id=30f1b224&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1b224",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f1b224')) {
      api.createRecord('30f1b224', component.options)
    } else {
      api.reload('30f1b224', component.options)
    }
    module.hot.accept("./block-sending.vue?vue&type=template&id=30f1b224&scoped=true", function () {
      api.rerender('30f1b224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/advanced/components/setting-email/components/alert-admin/block-sending.vue"
export default component.exports